import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleLayout from '@/components/feature/ArticleLayout';
import { articles } from '@/mocks/articles';

const relatedArticles = [
  { id: 'litbuy-spreadsheet-tips', title: 'LitBuy Spreadsheet Tips and Tricks' },
  { id: 'litbuy-spreadsheet-templates', title: 'Best LitBuy Spreadsheet Templates in 2026' },
  { id: 'litbuy-spreadsheet-workflow', title: 'LitBuy Spreadsheet Workflow Guide' },
];

export default function HowToUsePage() {
  return (
    <main>
      <Navbar />
      <ArticleLayout article={articles['how-to-use-litbuy-spreadsheet']} relatedArticles={relatedArticles} />
      <Footer />
    </main>
  );
}